import { LOGIC, WORDS } from './puzzleMainType'

export const all = 'all'
export type PuzzleFilter1 = typeof LOGIC | typeof WORDS | typeof all
